export default __webpack_public_path__ + "0bb0059d9cb95b3ccf383f613dac1ab8.png";